import { StudentReportsPageContent } from "@/pages/home/rapportages"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/home/rapportages/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <StudentReportsPageContent />
}
